<template>
  <PageTitle :pageTitle="t('leadsSettings')" :subTitle="t('common.settings')" />

  <LeadsSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import LeadsSettings from "@/components/Others/Settings/LeadsSettings/index.vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "LeadsSettingsPage",
  components: {
    PageTitle,
    LeadsSettings,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  }
});
</script> 
